import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "./AuthService";
import {apiconfig} from "../app/api.config";
import {
  OperationDailyWorkerSchedulingOptions,
  SlotAssignmentPerPoolReport,
  SlotsForStoreReport
} from "../model/ReportingSlots";

@Injectable()
export class ResourcePlanningService {


  apiConfig: any = apiconfig;

  /**
   * default constructor for Dep Injection
   * @param http
   * @param authService
   */
  constructor(private http: HttpClient, private authService: AuthService) {
  }


  loadSlotsForStoreAndOperation(dayId: number, operationId: number, storeId: number): Promise<SlotsForStoreReport> {

    let httpParams = new HttpParams();
    let h = this.authService.getHttpAuth();

    httpParams = httpParams.append("day", String(dayId));
    if (operationId != null)
      httpParams = httpParams.append("operation", String(operationId));

    if (storeId != null)
      httpParams = httpParams.append("store", "" + storeId);

    return this.http
      .get<any[]>(this.apiConfig.API_URL + '/order/slots/search', {
        headers: h,
        params: httpParams
      }).map((res: any) => res).toPromise().then((orders: SlotsForStoreReport) => {
        return SlotsForStoreReport.fromJson(orders);
      });

  }


  /**
   *
   * @param operationId
   */
  loadOperationPlanningTemplateOptions(operationId: number): Promise<OperationDailyWorkerSchedulingOptions> {
    let httpParams = new HttpParams();
    let h = this.authService.getHttpAuth();

    return this.http
      .get<OperationDailyWorkerSchedulingOptions>(this.apiConfig.API_URL + '/order/slots/operation/' + operationId + '/daily-worker-schedule-templates', {
        headers: h,
        params: httpParams
      }).map((res: any) => res).toPromise().then((e: OperationDailyWorkerSchedulingOptions) => {
        return OperationDailyWorkerSchedulingOptions.fromJson(e);
      });
  }


  /**
   * load report to display how many slots have been already planned with a store / mission
   * @param operationId
   * @param from
   * @param to
   * @param rangeType
   */
  loadOperationSlotPlanningProgressReport(operationId: number, from: number, to: number, rangeType: string): Promise<SlotAssignmentPerPoolReport> {
    let httpParams = new HttpParams();
    let h = this.authService.getHttpAuth();

    if (to != null)
      httpParams = httpParams.append("to", "" + to);

    if (from != null)
      httpParams = httpParams.append("from", "" + from);

    if (rangeType != null)
      httpParams = httpParams.append("rangeType", rangeType);
    else
      httpParams = httpParams.append("rangeType", 'WEEKLY');

    return this.http
      .get<SlotAssignmentPerPoolReport>(this.apiConfig.API_URL + '/order/slots/operation/' + operationId + '/slot-planning-report', {
        headers: h,
        params: httpParams
      }).map((res: any) => res).toPromise().then((e: SlotAssignmentPerPoolReport) => {
        return SlotAssignmentPerPoolReport.fromJson(e);
      });
  }


}



// WEBPACK FOOTER //
// ./src/services/ResourcePlanningService.ts